import { RawKey } from '@master/annotation/RawKey'
import { Meta } from '@master/model/common/Meta'

export const header = [
  '_oid',
  'name',
  'role',
  'account_fullname',
  'account_sfa_code',
  'account_mas_repno',
  'account_mobile'
]

export class MemberMeta extends Meta {
  @RawKey('_oid')
  oid = ''

  name = ''
  accountFullname = ''
  accountSfaCode = ''
  accountMasRepno = ''
  accountMobile = ''
  role = ''
}
